import { LogsExportForm } from "../components/organisms";

const LogPage = () => {
  return <LogsExportForm />;
};

export default LogPage;
